import { Phone, Calendar } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const MobileCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down a bit to not cover initial hero content
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 p-3 pb-5 z-50 md:hidden transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex gap-2">
        <a
          href="tel:2392344343"
          className="flex flex-col items-center justify-center flex-1 btn-luxury py-3 rounded-sm text-primary-foreground font-medium tracking-[0.2em] uppercase shadow-[0_0_30px_hsl(var(--primary)/0.3)] border border-primary/50"
        >
          <Phone className="w-4 h-4 mb-1" />
          <span className="text-[10px]">Call Now</span>
        </a>
        <Button
          asChild
          className="flex-1 btn-luxury rounded-none text-primary-foreground tracking-[0.2em] uppercase text-[10px] font-bold h-[60px] border-l border-primary/20"
        >
          <a
            href="https://customer.moovs.app/pam-car-service/new/info"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book Reservation
          </a>
        </Button>
      </div>
    </div>
  );
};
